import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ax-context-menu]',
    standalone: true,
})
export class ContextMenuDirective {
    constructor(public readonly viewRef: ViewContainerRef) {}
}
